module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg36.f18c8a32.jpg";